import { render, staticRenderFns } from "./TifAsignacionContableCecoAfe.vue?vue&type=template&id=a1afe554"
import script from "./TifAsignacionContableCecoAfe.vue?vue&type=script&lang=js"
export * from "./TifAsignacionContableCecoAfe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports